import React, { useState } from 'react'
import styles from "./SupervisorRecipeProduction.module.css"
// import TopTabDropdown from '../../../components/TopTabDropdown/TopTabDropdown'
import HeaderComponent from "../../../components/HeaderComponent/HeaderComponent";
import TopTabComponent from "../../../components/TopTabComponent/TopTabComponent";
import { ReactComponent as TabIcon } from "../../../assets/images/tabIcon.svg";
import Mixing from "./Mixing/Mixing";
import MakeUp from "./MakeUp/MakeUp";
import Proofing from "./Proofing/Proofing";
import Chilling from "./Chilling/Chilling";
import { SearchInput, SubmitButton, TextComponent, Modal, InputField, Dropdown } from "../../../components";
import { IoClose } from "react-icons/io5";
import { SearchOutlined } from "@ant-design/icons";
import { useNavigate } from 'react-router-dom';
import HeadingComponent from '../../../components/HeadingComponent/HeadingComponent';
import { Table } from 'antd';




const options = [
  { id: 1, name: "Mixing", Icon: <TabIcon width={16} height={16} /> },
  { id: 2, name: "Make-Up", Icon: <TabIcon width={16} height={16} /> },
  { id: 3, name: "Proofing", Icon: <TabIcon width={16} height={16} /> },
  { id: 4, name: "Chill", Icon: <TabIcon width={16} height={16} /> },

];

const stationOptions = [
  { id: 1, value: "Mixing station" },
  { id: 2, value: "Make-Up station" },
  { id: 3, value: "Proofing Station" },
  { id: 4, value: "Chilling Station" },
  { id: 5, value: "Oven" },
  { id: 6, value: "Assembly" },
  { id: 7, value: "Packaging" },
];

const statusOpt = [
  { id: 1, value: "Status" },
  { id: 2, value: "Completed" },
  { id: 3, value: "Schedule" },
  { id: 4, value: "In Progress" },
];


const SupervisorRecipeProduction = () => {
  const navigate = useNavigate();

  const [station, setStation] = useState("Mixing station")
  const [focusedTab, setFocusedTab] = useState(options[0]);
  const [onGoingTask, setOnGoingTask] = useState(false);
  const [filterModal, setFilterModal] = useState(false)
  const [status, setStatus] = useState({
    value: "Status",
    role: "Status",
    id: 1,
  });


  const ongoingColumns = [
    {
      title: "Task ID",
      dataIndex: "TaskID",
      key: "TaskID",
      render: (text, record) => {
        return (
          <TextComponent
            text={text}
            style={{ color: "black", fontFamily: "Inter-semiBold" }}
          />
        );
      },
    },
    {
      title: "Task Name",
      dataIndex: "TaskName",
      key: "TaskName",
      render: (text, record) => {
        return (
          <TextComponent
            text={text}
            style={{ color: "black", fontFamily: "Inter-semiBold" }}
          />
        );
      },
    },
    {
      title: "Action",
      key: "action",
      dataIndex: "Button",
      render: (text, record) => record.Button,
    },

  ];

  const ongoingData = [
    {
      TaskID: "#153485",
      TaskName: "Choc Chip Cookie",
      Button:
        <SubmitButton
          title={"View"}
          primary
          btnClass={styles.actionBtn}
          onClick={() => navigate("/supervisor/RecipeProduction/OngoingTask")}

        />
    },
    {
      TaskID: "#153485",
      TaskName: "Choc Chip Cookie",
      Button:
        <SubmitButton
          title={"View"}
          primary
          btnClass={styles.actionBtn}
          onClick={() => navigate("/supervisor/RecipeProduction/OngoingTask")}

        />
    },
    {
      TaskID: "#153485",
      TaskName: "Choc Chip Cookie",
      Button:
        <SubmitButton
          title={"View"}
          primary
          btnClass={styles.actionBtn}
          onClick={() => navigate("/supervisor/RecipeProduction/OngoingTask")}

        />
    },
    {
      TaskID: "#153485",
      TaskName: "Choc Chip Cookie",
      Button:
        <SubmitButton
          title={"View"}
          primary
          btnClass={styles.actionBtn}
          onClick={() => navigate("/supervisor/RecipeProduction/OngoingTask")}

        />
    },
    {
      TaskID: "#153485",
      TaskName: "Choc Chip Cookie",
      Button:
        <SubmitButton
          title={"View"}
          primary
          btnClass={styles.actionBtn}
          onClick={() => navigate("/supervisor/RecipeProduction/OngoingTask")}

        />

    },

  ];

  return (
    <div>
      <div className={styles.mainCont}>
        <div className={styles.HeadingDiv}>
          <HeaderComponent
            showBackIcon={false}
            heading={"Recipe Production"}
            headingStyle={styles.Heading}
            showSearch={true}
            rightControlsStyle={styles.searchDivStyle}
            showFilterIcon={true}
            onClickFilter={() => setFilterModal(true)}

          >
          </HeaderComponent>
          <div className={styles.InputHeader}>
            <div className={styles.SearchInput}>
              <Dropdown
                className={styles.inputNew}
                value={station}
                labelStyle={{ fontSize: 18 }}
                inputStyle={{
                  backgroundColor: "#F7F8F9",
                  border: "1.5px solid #E8ECF4",

                }}
                inputClass={styles.inputNew}
                style={{ color: "black" }}
                options={stationOptions}
                onChange={(item) => setStation(item.value)}
              />

            </div>
            <div className={styles.SearchButton}>
              <SubmitButton
                btnContainerClass={styles.btnContainer}
                btnClass={styles.btnClass}
                secondary
                title={"Ongoing Tasks"}
                onClick={() => {
                  setOnGoingTask(true);

                }}
              />
              <SubmitButton
                btnContainerClass={styles.btnContainer}
                btnClass={styles.btnClass}
                primary
                title={"Orders Checklist"}
                onClick={() => {
                  navigate("/Supervisor/OrderChecklist")
                }}
              />
            </div>
          </div>

          {/* ////////////////////////// Ongoing Tasks //////////////////////////////// */}
          <Modal
            subClassName={styles.modalContentStyle}
            open={onGoingTask}
            onCancel={() => {
              setOnGoingTask(false);
            }}

            className={styles.Modal}
            okBtnTitle={"Confirm"}
            cancelBtnTitle={"Cancel"}
          // width={"90%"}
          // onBtnPress={() => setAddMembers(false)}
          >
            <HeadingComponent
              text={"Ongoing Tasks"}
              className={styles.modalHead}

            />
            <div className={styles.TableDiv}>
              <Table
                scroll={{ x: true }}
                columns={ongoingColumns}
                dataSource={ongoingData}
                pagination={false}
              />
            </div>
          </Modal>



          {/* //////////////////// Filters ////////////////////// */}

          <Modal
            open={filterModal}
            onCancel={() => {
              setFilterModal(false);
            }}
            className={styles.modalCont}
            title={"Filters"}
            headingClass={styles.modalHeading}
            width={"400px"}

            twoButton
            okBtnTitle={"Apply Filters(1)"}
            cancelBtnTitle={"Reset All"}
            onClickCancelButton={() => setFilterModal(false)}
            onClickOkButton={() => {
              setFilterModal(false)
            }}

          >
            <Dropdown
              // label={"Stations"}
              // labelClass={styles.DropDownLabel}
              value={status}
              inputStyle={{
                backgroundColor: "#F7F8F9",
                border: "1.5px solid #E8ECF4",
              }}
              inputClass={styles.DropdownInput}
              style={{ color: "var(--black-color)" }}
              options={statusOpt}
              onChange={(e) => setStatus(e)}
            />


          </Modal>


          {station === "Mixing station" && <Mixing />}
          {station === "Make-Up station" && <MakeUp />}
          {station === "Proofing Station" && <Proofing />}
          {station === "Chilling Station" && <Chilling />}
        </div>
      </div>
    </div>
  )
}

export default SupervisorRecipeProduction


